import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { Grid2, Typography, useTheme, styled } from '@mui/material';
import CircularIndeterminate from '../Progress';
import ResourceGrid from '../ResourceGrid';
import PaxComponent from '../PaxComponent';

/* import { useTranslation } from 'core/contexts/localization';*/
import { useLocation } from 'react-router-dom';
import ExperienceDatePicker from './components/ExperienceDatePicker';

type ResourceSelectedState = { [categoryId: number]: number[] }[];

export interface Resource {
  id?: number;
  resourceId?: number;
  name?: string;
  resourceName?: string;
  resourceCategoryId?: number;
}

export interface Category {
  resourceCategoryId: number;
  name: string;
  resources: Resource[];
  categoryName?: string;
  categoryId?: number;
}

interface SelectedSlot extends Slot {
  priceTotal?: string | number;
  timeOfArrivalFormatted?: string;
}
interface Slot {
  start: string;
  startUTC: string;
  endUTC: string;
  end: string;
  timezone: string;
  currency: string;
  available: boolean;
  price?: string | number;
  id: number;
  duration: number;
}
interface Experience {
  id: string | number;
  name?: string;
  experienceDetailId: number;
}

export interface ExperienceAvailabilityPageProps {
  showLoading?: boolean;
  showPrice?: boolean;
  showTitle?: boolean;
  showQuantity?: boolean;
  quantity?: number;
  datePicker: Date | null;
  resources?: Category[];
  slots: Slot[];
  experience?: Experience | null;
  setQuantity?: React.Dispatch<React.SetStateAction<number>>;
  setDatePicker: React.Dispatch<React.SetStateAction<Date>>;
  setVisibleRange: (range: any) => void;
  setSelectedSlot: (slot: SelectedSlot | null) => void;
  setResourceSelected: Dispatch<SetStateAction<ResourceSelectedState>>;
  resourceSelected: Resource | null;
}

const ExperienceAvailabilityPageComponent: React.FC<
  ExperienceAvailabilityPageProps
> = ({
  showLoading = false,
  showPrice = false,
  showTitle = true,
  showQuantity = true,
  quantity,
  datePicker,
  resources,
  slots = [],
  experience,
  setQuantity,
  setDatePicker,
  setVisibleRange,
  setSelectedSlot,
  setResourceSelected,
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const urlDate = searchParams.get('date');
  const urlQuantity = searchParams.get('quantity');
  const theme = useTheme();

  useEffect(() => {
    if (urlQuantity && setQuantity) {
      setQuantity(parseInt(urlQuantity));
    }
    if (urlDate) {
      setDatePicker(new Date(`${urlDate}T21:00:00-00:00`));
    }
  }, [urlDate, urlQuantity]);

  const LoaderContainer = styled('div')(() => ({
    top: '0',
    position: 'absolute',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '99999999999999999999',
    background: '#f8f8f8',
    opacity: '.8',
  }));

  return (
    <Grid2
      sx={{
        [theme.breakpoints.up('sm')]: {},
        display: 'flex',
        alignContent: 'center',
        flexDirection: 'column',
        minWidth: '312px',
        position: 'relative',
      }}
      container
      translate="no">
      {' '}
      {showLoading ? (
        <LoaderContainer>
          <div>
            <CircularIndeterminate centered={true} />
          </div>
        </LoaderContainer>
      ) : (
        ''
      )}
      <Grid2
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
        size={12}>
        {showTitle ? (
          <Grid2
            sx={{
              paddingTop: '0.5rem',
              maxWidth: '19rem',
              wordWrap: 'break-word',
            }}>
            <Typography variant="h3">{experience?.name}</Typography>
          </Grid2>
        ) : (
          ''
        )}

        {showQuantity && setQuantity ? ( // REVISAR!
          <Grid2 sx={{ marginTop: '8px' }}>
            <PaxComponent setAdults={setQuantity} adults={quantity || 1} />
          </Grid2>
        ) : (
          ''
        )}

        {resources ? (
          <ResourceGrid
            categories={resources}
            setResourceSelected={setResourceSelected}
          />
        ) : (
          ''
        )}

        <ExperienceDatePicker
          setDatePicker={setDatePicker}
          setVisibleRange={setVisibleRange}
          quantity={quantity || 1}
          datePicker={datePicker}
          slots={slots}
          showPrice={showPrice}
          experience={experience}
          setSelectedSlot={setSelectedSlot}
        />
      </Grid2>
    </Grid2>
  );
};

export default ExperienceAvailabilityPageComponent;
